import e from "classnames";
import t from "react";
const o = "_productCard__skeleton_olhq4_1", a = "_productCard__skeletonImg_olhq4_33 _productCard__skeletonAnimation_olhq4_21", s = "_productCard__skeletonBrand_olhq4_40 _productCard__skeletonAnimation_olhq4_21", c = "_productCard__skeletonTitle_olhq4_47", l = "_productCard__skeletonPrice_olhq4_81 _productCard__skeletonAnimation_olhq4_21", r = {
  productCard__skeleton: o,
  productCard__skeletonImg: a,
  productCard__skeletonBrand: s,
  productCard__skeletonTitle: c,
  productCard__skeletonPrice: l
};
function n({
  className: _,
  ...d
}) {
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: e(r.productCard__skeleton, "fuse-product-card__skeleton", _),
      "data-testid": "fuse-product-card__skeleton",
      ...d
    },
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: e(r.productCard__skeletonImg, "fuse-product-card-skeleton__image"),
        "data-testid": "fuse-product-card-skeleton__image"
      }
    ),
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: e(
          r.productCard__skeletonBrand,
          "fuse-product-card-skeleton__brand"
        ),
        "data-testid": "fuse-product-card-skeleton__brand"
      }
    ),
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: e(
          r.productCard__skeletonTitle,
          "fuse-product-card-skeleton__title"
        ),
        "data-testid": "fuse-product-card-skeleton__title"
      }
    ),
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: e(
          r.productCard__skeletonPrice,
          "fuse-product-card-skeleton__price"
        ),
        "data-testid": "fuse-product-card-skeleton__price"
      }
    )
  );
}
n.displayName = "SkeletonCard";
export {
  n as SkeletonCard
};
